import { removeEmptyEntries } from "@lib-shared/lib";
import { CustomerAccountDetails, PrimaryAddressDetails, PrimaryContactDetails } from "core/types/business-details";

class BusinessDetailsSummary {
    contactName = "";
    role = "";
    email = "";
    phone: string | null = "";
    address: PrimaryAddressDetails | null = null;
    registrationNumber = "";
    vatNumber = "";
    additionalContact: string | null = "";

    constructor(data: CustomerAccountDetails) {
        const {
            companyDetails
        } = data;

        const getItemAtIndex = (arr: Array<any>, index = 0) => {
            return arr != null && arr.length >= index ? arr[index] : null;
        }

        const address = getItemAtIndex(data.primaryAddressDetails);
        const personalDetails = getItemAtIndex(data.primaryPersonalDetails);
        const email = getItemAtIndex(data.primaryEmailAddress);
        const additionalContact = getItemAtIndex(data.primaryContactDetails, 1);

        const names = [personalDetails?.title, personalDetails?.firstName, personalDetails?.surname];

        const contactName = removeEmptyEntries(names).join(" ");

        const getPhoneNumberWithCountryCode = (contact: PrimaryContactDetails) => contact
            ? `+${contact?.countryCode} ${contact?.workNumber ?? contact?.cellNumber}`
            : null;

        const getPrimaryContactDetails = () => {
            const contact = data.primaryContactDetails.find(x => x.phoneType === "Work");
            return contact ?? data.primaryContactDetails[0];
        }

        this.contactName = contactName;
        this.role = personalDetails?.role;
        this.email = email?.email;

        const primaryContactDetails = getPrimaryContactDetails();
        this.phone = getPhoneNumberWithCountryCode(primaryContactDetails);

        this.address = address;
        this.registrationNumber = companyDetails?.businessRegistrationNumber;
        this.vatNumber = companyDetails?.vatNumber;
        this.additionalContact = getPhoneNumberWithCountryCode(additionalContact);
    };
}

export default BusinessDetailsSummary;
